import { PaymentGroupName, PaymentProvider } from '../enums/BuyPaymentEnums';
import { CustomerDetails } from './Customer';

export type PaymentInfo = {
  chosenDeliveryOption?: string;
  chosenPaymentOption?: PaymentGroupName | null;
  chosenPaymentOptionId?: number;
  customerDetails?: CustomerDetails;
  deliveryAddress?: PaymentInfoDeliveryAddress;
  deliveryPromiseMessage?: string;
  deliveryPromiseCutoff: string | null;
  hasDeliveryMessage: boolean;
  fullyPaid?: boolean;
  hostedTokenization?: boolean;
  invoiceAddress?: InvoiceAddress;
  needInvoice?: boolean;
  orderReference?: string;
  paymentGroups?: Array<PaymentGroup>;
  paymentOptions?: Array<PaymentOption>;
  phoneNumber1?: string;
  phoneNumber2?: string;
  requiresDelivery?: boolean;
  validateRegex?: string;
};

export type PaymentInfoDeliveryAddress = {
  address?: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  addToProfile?: boolean;
  city?: string;
  companyName?: string;
  country?: string;
  county?: string;
  deliveryAddressId?: number;
  extraOptions?: string;
  firstName?: string;
  houseNumber?: string;
  houseNumberAddition?: string;
  idCountry?: number;
  idTitle?: number;
  lastName?: string;
  middleName?: string;
  phoneNumber?: string;
  postCode?: string;
  shopId?: number;
  stateIso?: string;
  storeId?: number;
  storeNumber?: number;
  organisationName?: string;
  locationName?: string;
  pickupPointNumber?: string;
  customerAccountId?: string;
  pickupPointName?: string;
  state?: string;
  defaultAddress?: boolean;
};

export type PaymentGroup = {
  name: string;
  ogoneAliases: Array<CreditCard> | null;
  paymentOptions: Array<PaymentOption>;
  sortOrder: number;
  supportsTokenization: boolean;
  weight: number;
  amountPayableWithOption: number | null;
};

export type CreditCard = {
  id: string;
  cardNumber: string;
  brand: string;
  cardName: string;
  expiryDate: string;
  providerCode: string;
};

export type PaymentData = {
  chosenPaymentOption: string;
  chosenPaymentOptionId: number;
  provider?: PaymentProvider;
  tp?: string;
};

export type PaymentOption = {
  deliveryPrice?: number;
  enabled?: boolean;
  exceededMaxBasketCost?: boolean;
  exceededWarningBasketCost?: boolean;
  group?: string;
  issuerId?: string;
  maxBasketCost?: number;
  minBasketCost?: number;
  name: string;
  paymentMethodCode?: string;
  paymentOptionId?: number;
  provider?: PaymentProvider;
  reasonNotValidForBasket?: Array<string>;
  sortOrder?: number;
  validForBasket?: boolean;
  warningBasketCost?: number;
  webImage?: string;
  weight?: number;
};

export type InvoiceAddress = {
  address?: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  city?: string;
  cityFrench?: string;
  country?: string;
  county?: string;
  houseNumber?: string;
  houseNumberAddition?: string;
  idCountry?: number;
  postCode?: string;
};

export type PaymentProviderInformation = {
  provider: PaymentProvider;
  postPaymentBasketId: string;
  paymentMethodCategory?: string;
  clientToken?: string;
};

export type OrderInfo = {
  orderReference: string;
};

export type SelectedPaymentOption = {
  name: string | null;
  id: number | null;
};

export type PaymentRequestInfo = Partial<PaymentInfo> & {
  alreadyPaid?: number;
  total?: number;
  toPay?: number;
  currency?: string;
  valid?: boolean;
  customerDateOfBirth?: string;
  vatNumber?: string;
};

export type PaymentRequestProviderInfo = {
  provider: PaymentProvider;
  paymentRequestId: number;
};

export type PaymentRequestConfirmation = {
  orderId: number;
  paymentRequestId: number;
  deliveryAddress: {
    firstName: string;
    middleName: string;
    surname: string;
    address: string;
    street: string;
    addressNumber: string;
    box?: string;
    postalCode: string;
    city: string;
    countryId: number;
    email: string;
    telephone: null;
  };
  invoiceAddress: {
    middleName: string;
    surname: string;
    address: string;
    street: string;
    addressNumber: string;
    box?: string;
    postalCode: string;
    city: string;
    countryId: number;
    email: string;
    telephone: null;
  };
};
